























import { Vue, Component, Prop } from "vue-property-decorator";
import Modifier from "./Modifier.vue";
import ModifiersData from "./ModifiersData";
import formatService from '@/services/format'

@Component({
    components: {
        Modifier
    }
})
export default class Modifiers extends Vue {
    @Prop() modifiers!: HourPrice.Modifiers;
    @Prop() result!: HourPrice.Result;
    @Prop() value!: string[];

    private ModifiersData = ModifiersData;
    private format = formatService;

    private setValue ($event: any) {
        const { checked, value } = $event.target;
        let newValue = this.value.concat();
        if (checked) {
            newValue = this.value.concat([value]);
        } else {
            newValue = this.value.filter(v => v !== value);
        }
        // this.$forceUpdate();
        this.$emit('input', newValue)
    }

    private getValue (): string[] {
        return this.value;
    }

    private hasValue (value: string): boolean {
        return this.getValue().includes(value);
    }
}
